import { createElement, Fragment } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __, sprintf } from '@wordpress/i18n';
import { Button } from '@wordpress/components';
import { createBlock, getBlockType } from '@wordpress/blocks';
import { RawHTML } from '@wordpress/element';
import { useDispatch, useSelect } from '@wordpress/data';
import { Warning } from '@wordpress/block-editor';
/**
 * Internal dependencies
 */

import InstallButton from './install-button';
import { store as blockDirectoryStore } from '../../store';

var getInstallMissing = function getInstallMissing(OriginalComponent) {
  return function (props) {
    var _props$attributes = props.attributes,
        originalName = _props$attributes.originalName,
        originalUndelimitedContent = _props$attributes.originalUndelimitedContent; // Disable reason: This is a valid component, but it's mistaken for a callback.
    // eslint-disable-next-line react-hooks/rules-of-hooks

    var _useSelect = useSelect(function (select) {
      var _select = select(blockDirectoryStore),
          getDownloadableBlocks = _select.getDownloadableBlocks;

      var blocks = getDownloadableBlocks('block:' + originalName).filter(function (_ref) {
        var name = _ref.name;
        return originalName === name;
      });
      return {
        hasPermission: select('core').canUser('read', 'block-directory/search'),
        block: blocks.length && blocks[0]
      };
    }, [originalName]),
        block = _useSelect.block,
        hasPermission = _useSelect.hasPermission;

    var _useDispatch = useDispatch('core/block-editor'),
        replaceBlock = _useDispatch.replaceBlock;

    var convertToHTML = function convertToHTML() {
      replaceBlock(props.clientId, createBlock('core/html', {
        content: originalUndelimitedContent
      }));
    };

    if (!hasPermission || !block) {
      return createElement(OriginalComponent, props);
    }

    var hasContent = !!originalUndelimitedContent;
    var hasHTMLBlock = getBlockType('core/html');
    var messageHTML = sprintf(
    /* translators: %s: block name */
    __('Your site doesn’t include support for the %s block. You can try installing the block or remove it entirely.'), block.title || originalName);
    var actions = [createElement(InstallButton, {
      key: "install",
      block: block,
      attributes: props.attributes,
      clientId: props.clientId
    })];

    if (hasContent && hasHTMLBlock) {
      messageHTML = sprintf(
      /* translators: %s: block name */
      __('Your site doesn’t include support for the %s block. You can try installing the block, convert it to a Custom HTML block, or remove it entirely.'), block.title || originalName);
      actions.push(createElement(Button, {
        key: "convert",
        onClick: convertToHTML,
        isLink: true
      }, __('Keep as HTML')));
    }

    return createElement(Fragment, null, createElement(Warning, {
      actions: actions
    }, messageHTML), createElement(RawHTML, null, originalUndelimitedContent));
  };
};

export default getInstallMissing;
//# sourceMappingURL=index.js.map